import { render, staticRenderFns } from "./ReporteTicketPromedio.vue?vue&type=template&id=07c6868f&scoped=true"
import script from "./ReporteTicketPromedio.vue?vue&type=script&lang=js"
export * from "./ReporteTicketPromedio.vue?vue&type=script&lang=js"
import style1 from "./ReporteTicketPromedio.vue?vue&type=style&index=1&id=07c6868f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c6868f",
  null
  
)

export default component.exports